/* @ngInject */
function savedRepliesService (ConnectorWebService, CONSTANTS, Utils) {
  var service = {
    getCompanySavedReplies,
    updateSavedReply,
    createSavedReply,
    deleteSavedReply
  }
  return service

  function getCompanySavedReplies () {
    return ConnectorWebService.get(CONSTANTS.URL_SAVED_REPLIES)
  }

  function updateSavedReply (id, savedReply) {
    const sUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_SAVED_REPLIES_ID, [id])
    return ConnectorWebService.put(sUrl, savedReply)
  }

  function createSavedReply (savedReply) {
    return ConnectorWebService.post(CONSTANTS.URL_SAVED_REPLIES, savedReply)
  }

  function deleteSavedReply (id) {
    const sUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_SAVED_REPLIES_ID, [id])
    return ConnectorWebService.fnDelete(sUrl)
  }
}

export { savedRepliesService }
